import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import emailjs from '@emailjs/browser'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import emailjsConfig, { hasEmailjsConfig } from '../../emailjs-config.js'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [searchParams] = useSearchParams()
  const form = useRef(null)
  const defaultSubject = searchParams.get('subject') || ''

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  const sendEmail = async (event) => {
    event.preventDefault()
    setError('')

    const formData = new FormData(form.current)
    const name = String(formData.get('name') || '').trim()
    const email = String(formData.get('email') || '').trim()
    const subject = String(formData.get('subject') || '').trim()
    const message = String(formData.get('message') || '').trim()

    if (!name || !email || !subject || !message) {
      const nextError = 'Please fill in all fields.'
      setError(nextError)
      toast.error(nextError)
      return
    }

    if (!isEmailValid(email)) {
      const nextError = 'Please enter a valid email address.'
      setError(nextError)
      toast.error(nextError)
      return
    }

    if (!hasEmailjsConfig) {
      const nextError = 'The contact service is not configured yet.'
      setError(nextError)
      toast.error(nextError)
      return
    }

    setIsSubmitting(true)

    try {
      await emailjs.sendForm(
        emailjsConfig.serviceID,
        emailjsConfig.templateID,
        form.current,
        emailjsConfig.userID
      )
      toast.success('Message sent successfully.')
      form.current.reset()
    } catch (sendError) {
      const nextError =
        sendError?.text ||
        sendError?.message ||
        'Message could not be sent. Please try again later.'
      setError(nextError)
      toast.error(nextError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelance opportunities, product work, and
            technical support requests. Send me a message and I will get back to
            you as soon as possible.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    defaultValue={defaultSubject}
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                {error && <li className="form-error">{error}</li>}
                <li className="button">
                  <button
                    type="submit"
                    className="flat-button"
                    disabled={isSubmitting}
                    aria-busy={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send'}
                  </button>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Lamine MESSACI,
          <br />
          France
          <br />
          Gardanne
          <br />
          <br />
          <span>lamine.messaci@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[43.43246, 5.4671]} zoom={14}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[43.43246, 5.4671]}>
              <Popup>Lamine Messaci - Gardanne, France</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
